import React from 'react';
import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'light' | 'dark';
  fullPage?: boolean;
  text?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  color = 'primary',
  fullPage = false,
  text
}) => {
  const spinnerClasses = [
    styles.spinner,
    styles[`spinner-${size}`],
    styles[`spinner-${color}`]
  ].join(' ');

  const containerClasses = [
    styles.container,
    fullPage ? styles.fullPage : ''
  ].join(' ');

  return (
    <div className={containerClasses}>
      <div className={spinnerClasses}></div>
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
};

export default Spinner;
